import { CenteredLoading, mt } from '@openeducation/oe-rn-components';
import { selectedLiveClassFeedbackAtom } from '@openeducation/oe-rn-jotai-atoms';
import {
  useCountry,
  useLiveClassFeedbacks,
  useStudentProfileLite,
} from '@openeducation/oe-rn-providers';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { View } from 'react-native';

import { TestId } from '../../constants/test-id';
import { PCFeedbackPanel } from '../pc-feedback-panel/pc-feedback-panel';
import { SelectedFeedbackHeader } from '../selected-pc-feedback-panel-header/selected-pc-feedback-panel-header';

export const SelectedPCFeedbackPanel = () => {
  const selectedLiveClassFeedback = useAtomValue(selectedLiveClassFeedbackAtom);
  const { countryCode } = useStudentProfileLite({
    studentId: selectedLiveClassFeedback?.studentId,
  });
  const { country } = useCountry({ countryId: countryCode });

  const { liveClassFeedbacks, isLoadingLiveClassFeedbacks } =
    useLiveClassFeedbacks({
      contactId: selectedLiveClassFeedback?.studentContactId,
    });

  if (!selectedLiveClassFeedback || isLoadingLiveClassFeedbacks) {
    return <CenteredLoading size={100} style={mt(100)} />;
  }

  return (
    <View testID={TestId.SELECTED_PC_FEEDBACK_PANEL}>
      <SelectedFeedbackHeader
        selectedFeedback={selectedLiveClassFeedback}
        countryName={country?.countryName}
      />
      <PCFeedbackPanel liveClassFeedbacks={liveClassFeedbacks} />
    </View>
  );
};
